import { SerializedData, Store } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { getBexApiContext } from "bernie-context";
import { ExtendedContextStore } from "../typings/flexFramework/FlexDefinitions";
import { TravelAgentSearchWizardConfigQuery } from "../../__generated__/api";
import { BexApiService } from "../services/BexApiService";
import { FAILED_TRAVEL_AGENT_SEARCH_WIZARD_CONFIG_FETCH } from "../config/systemEvents";

export class TravelAgentSearchWizardConfigStore extends Store {
  private bexApiService: BexApiService;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, bexApiService: BexApiService) {
    super(state, logger);
    this.bexApiService = bexApiService;
  }

  public hydrate(data: SerializedData): void {
    // The serialized store as returned by the server exposes a stripped down
    // version of bexApiService with no methods.  We delete it here to prevent the override.
    delete data.bexApiService;
    Object.assign(this, data);
  }

  public async fetchTravelAgentSearchWizardConfig(contextStore: ExtendedContextStore): Promise<any> {
    const variables: TravelAgentSearchWizardConfigQuery.Variables = {
      context: getBexApiContext(contextStore),
    };
    try {
      const query = await this.bexApiService.fetchTravelAgentSearchWizardConfigQuery(variables);

      return query.data.travelAgentSearchWizardConfig;
    } catch (err) {
      this.logger.logEvent(
        FAILED_TRAVEL_AGENT_SEARCH_WIZARD_CONFIG_FETCH,
        "Unexpected error when fetching travel agent search wizard config",
        err
      );
      return { errorMessage: "Unexpected error when fetching travel agent search wizard config" };
    }
  }
}
